import './App.css';
import axios from "axios";
import { Form, Button} from 'semantic-ui-react';
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

{/*const options = [
  { value: 'aj', label: 'Anglický jazyk' },
  { value: 'mat', label: 'Matematika' },
  { value: 'čj', label: 'Český jazyk' }
]

const options2 = [
  { value: 'ZŠ', label: 'Doučování pro ZŠ' },
  { value: 'SŠ', label: 'Doučování pro SŠ' },
  { value: 'PS', label: 'Doučování na přijímačky' }
]

const MyComponent = () => (
  <Select options={options} className="form-contro2" placeholder="Předmět/-y doučování*" styles={{
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderRadius: '0.5rem',
      border: state.isFocused ? "0.125rem solid rgb(82, 220, 244)" : "0.125rem solid #ced4da",
      boxShadow: state.isFocused ? '0 0 0 0.25rem rgb(82, 220, 244,0.25)' : '#fff',
      "&:hover": {
      border: "",
      
    }
 
    }),
  }}
    touchUi={false}  isMulti />
)

const MyComponent2 = () => (
  <Select options={options2} className="form-contro2" placeholder="Varianta doučování*" styles={{
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderRadius: '0.5rem',
      border: state.isFocused ? "0.125rem solid rgb(82, 220, 244)" : "0.125rem solid #ced4da",
      boxShadow: state.isFocused ? '0 0 0 0.25rem rgb(82, 220, 244,0.25)' : '#fff',
      "&:hover": {
      border: "",
      
    }
 
    }),
  }}
    touchUi={false}   />
)
*/}

export default function App() {
 const form = useRef();
 


 const sendEmail = (e) => {
   //e.preventDefault(); // prevents the page from reloading when you hit “Send”
   
   //emailjs.sendForm('service_jcbveoo', 'template_n9irp4m', form.current, 'S0bNuhRoRL5ffSah2')
     emailjs.sendForm('service_bhr1i9i', 'template_1i0y6h7', form.current, '7kGxGq1k21ErShxfF')
     .then((result) => {
  alert('Děkujeme! Ozveme se Vám nejpozději do 24 hodin! Kromě složky Přijatých zpráv zkontrolujte, prosím, také i svou složku Nevyžádaná pošta a Spam.'); 
  reset({name:"", email:"", phone:"", name_child:"", subject:"", subject_variant:"", casove_moznosti:"", poznamka:"", checkBox:"", checkBox2:""});
  window.scrollTo(0, 0);
  emailjs.sendForm('service_bhr1i9i', 'template_2120wjb', form.current, '7kGxGq1k21ErShxfF')
 
     }, (error) => {
         alert('Je nám to líto! Něco se pokazilo! Zkuste to, prosím, znovu.');
     });
 };

const methods = useForm();
    const { register, control, handleSubmit, reset, formState: { errors } } = useForm();

     
    return (
        <div >
                   
		           <div className="card-body" style={{border:'solid #52dcf4 0.5px',borderRadius:'15px', padding:'2%!important'}}>
		           <h5>Máte zájem?</h5><p> <strong>Vyplňte formulář</strong> a my se Vám do 24 hodin ozveme zpátky!</p>
		            <hr></hr>
		            
		            <form ref={form} onSubmit={handleSubmit(sendEmail)}>
                
                
		    <div className=" mb-1">
                    
			
			<label>
			Jméno a příjmení rodiče*
                    <input className="form-contro" 
                        type="text" placeholder="" style={{color:'black!important', zIndex:'1000!important'}}
                        {...register("name", { required: true})} autoComplete="off"
                    />
		    </label>
		    </div>
                {errors.name && <p style={{color:"red"}}>Pole Jméno a příjmení rodiče je požadováno</p>}
                
                <div className="row">
                <div className="col-sm-6">
                <div className=" mb-1">   
                         <label>E-mail*          
                    <input
                        className="form-contro" id="email" type="email" placeholder=""
                        {...register("email",{
                                required: true,
                                pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                            })}
                    />
		    </label>
		    </div>

		{errors.email && <p style={{color:"red"}}>Pole E-mail je požadováno</p>}
		</div>
		<div className="col-sm-6">
		    <div className=" mb-1">
		       <label>Telefon*         
                    <input
                        className="form-contro" id="phone" type="phone" placeholder=""
                        {...register("phone",{required: true, patten: /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i})}
                    />
		    </label>
		    </div>
		    
		    {errors.phone && <p style={{color:"red"}}>Pole Telefon je požadováno</p>}
                </div>
                </div>
                <div className=" mb-1">
                    <label> Jméno a příjmení dítěte*
                    <input className="form-contro" 
                        type="text" placeholder=""
                        {...register("name_child", { required: true})}
                    />
		    </label>
		    </div>
                {errors.name_child && <p style={{color:"red"}}>Pole Jméno a příjmení dítěte je požadováno</p>}
                
                <div className="row">
                <div className="col-sm-6">
                <div className=" mt-2 mb-2">
                    
                    <select {...register('subject_variant', { required: true})} className="form-contro" placeholder="">
                    <option value = "" disabled selected> Varianta doučování<span className="required">*</span></option>
                    <option>Doučování pro ZŠ</option>
                    <option>Doučování pro SŠ</option>
                    <option>Doučování na přijímačky pro SŠ</option>       
                    <option>Doučování na přijímačky pro VŠ</option>                    
                    </select>
		    </div>
                {errors.subject_variant && <p style={{color:"red"}}>Pole Varianta doučování je požadováno</p>}

                </div>
                <div className="col-sm-6">
               
                <div className=" mt-2 mb-2" >
                    <select {...register('subject', { required: true})} className="form-contro" placeholder="í" >
                    <option value = "" disabled selected> Předmět/-y doučování<span className="required">*</span></option>
                    <option>Anglický jazyk</option>
                    <option>Matematika</option>
                    <option>Český jazyk</option>
                    <option>jiné</option>
                    
                    </select>
		    </div>
                {errors.subject && <p style={{color:"red"}}>Pole Předmět/-y doučování je požadováno</p>}
                
                                </div>
                
                
                </div>
                <div className="mb-1">   
                <label> Preferované časy doučování*                
                    <textarea className="form-contro" id="casove_moznosti" type="text" placeholder="" style={{height: "2.5rem"}}
                        {...register("casove_moznosti",{required:true})}
                    />
		    </label>
		    </div>
		  {errors.casove_moznosti && <p style={{color:"red"}}>Pole Preferované časy doučování je požadováno</p>}  
		   
        
        
                <div className="mb-3">   
                <label> Poznámka                 
                    <textarea className="form-contro" id="message" type="text" placeholder="" style={{height: "5rem"}}
                        {...register("poznamka")}
                    />
		    </label>
		    </div>
		    
		    <div className="form-floating mb-3"> 
<input type="hidden" readonly="readonly" {...register("msg", { value: "Individuální doučování online" })} />
</div> 

<div className=""> 
	<p><label style={{color:"black"}}><input className="form-contro2"
              type="checkbox"
              name="selectCheckbox"
              id="selectCheckbox"
              {...register('checkBox', { required: true})}
              
            /> Souhlasím s <a className="agdpr" data-toggle="modal" data-target="#myModal2">Zásady ochrany osobních údajů</a><span className="required" style={{color:"black"}}>*</span></label></p>

</div>
  {errors.checkBox && <p style={{color:"red"}}>Pole Souhlasím s Zásady ochrany osobních údajů je požadováno</p>} 
                
<div className=""> 
	<p><label style={{color:"black"}}><input className="form-contro2"
              type="checkbox"
              name="selectCheckbox2"
              id="selectCheckbox2"
              {...register('checkBox2', { required: true})}
              
            /> Souhlasím s <a className="agdpr" href="VOP/VOP_01.01.2025.pdf" target="_blank" rel="noopener noreferrer">Všeobecné obchodní podmínky</a><span className="required" style={{color:"black"}}>*</span></label></p>

</div>
  {errors.checkBox2 && <p style={{color:"red"}}>Pole Souhlasím s Všeobecné obchodní podmínky je požadováno</p>}     
    
<div className=""> 
	<p><label style={{color:"black"}}><input className="form-contro2 onoffswitch-checkbox" 
              type="checkbox"
              name="selectCheckbox3"
              id="selectCheckbox3"
              {...register('checkBox3',)}
              defaultChecked
            /> Souhlasím se zasílaním Newsletterů</label></p>

</div>    
    

    
                <Button className="btn   justify-center btcol"  type="submit">Odeslat</Button>
		            </form>
			  </div>
                   
                   
                   </div>
    )
}


